"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Text = _interopRequireDefault(require("../Text/Text"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ChartKey = function ChartKey(_ref) {
  var variant = _ref.variant,
      children = _ref.children,
      color = _ref.color,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "children", "color"]);

  return (0, _themeUi.jsx)(_themeUi.Flex, _extends({}, props, {
    sx: {
      alignItems: 'center'
    }
  }), (0, _themeUi.jsx)(_themeUi.Box, {
    sx: _extends({
      bg: color,
      flex: '0 0 auto'
    }, variant === 'circle' && {
      width: '8px',
      height: '8px',
      borderRadius: '50%'
    }, variant === 'line' && {
      width: 5,
      height: function height(theme) {
        return theme.borderWidths.thick + "px";
      }
    }, variant === 'square' && {
      width: 1,
      height: 1,
      borderRadius: 'small'
    })
  }), (0, _themeUi.jsx)(_Text["default"], {
    variant: "caption",
    sx: {
      ml: 2
    }
  }, children));
};

ChartKey.propTypes = {
  children: _propTypes["default"].node,
  color: _propTypes["default"].string,
  variant: _propTypes["default"].oneOf(['circle', 'line', 'square'])
};
ChartKey.defaultProps = {
  children: null,
  color: 'neutral.1',
  variant: 'circle'
};
var _default = ChartKey;
exports["default"] = _default;